import React from 'react';
import PropTypes from 'prop-types';

const ConsentReleaseForm = ({ data, signatureData }) => {

  // Checkbox component
  const Checkbox = ({ checked, style }) => (
    <span style={{
      display: 'inline-block',
      width: '14px',
      height: '14px',
      border: '1px solid #000',
      marginRight: '5px',
      position: 'relative',
      verticalAlign: 'middle',
      ...style
    }}>
      {checked && (
        <>
          <span style={{
            position: 'absolute',
            width: '10px',
            height: '2px',
            backgroundColor: '#000',
            top: '6px',
            left: '2px',
            transform: 'rotate(45deg)'
          }}></span>
          <span style={{
            position: 'absolute',
            width: '6px',
            height: '2px',
            backgroundColor: '#000',
            top: '5px',
            left: '4px',
            transform: 'rotate(-45deg)'
          }}></span>
        </>
      )}
    </span>
  );

  // Information types organized in 3 columns × 6 rows
  const informationTypes = [
    [
      { label: "Presence in treatment", checked: data.infoPresence },
      { label: "Medical history/current status", checked: data.infoMedical },
      { label: "Progress in treatment", checked: data.infoProgress }
    ],
    [
      { label: "Biopsychosocial assessment", checked: data.infoAssessment },
      { label: "Aftercare recommendations", checked: data.infoAftercare },
      { label: "Discharge planning", checked: data.infoDischarge }
    ],
    [
      { label: "Treatment plans", checked: data.infoTreatment },
      { label: "Laboratory test results", checked: data.infoLab },
      { label: "Psychological assessment", checked: data.infoPsych }
    ],
    [
      { label: "Discharge summary", checked: data.infoSummary },
      { label: "Employment information", checked: data.infoEmployment },
      { label: "Psychiatric history and assessment", checked: data.infoPsychHistory }
    ],
    [
      { label: "Legal status", checked: data.infoLegal },
      { label: "Other: " + (data.infoOther || "__________"), checked: data.infoOtherChecked },
      { label: "Results of physical exam", checked: data.infoPhysical }
    ],
    [
      { label: "Family information", checked: data.infoFamily },
      null, // Empty cell
      null  // Empty cell
    ]
  ];

  // Reasons for release
  const reasons = [
    { label: "Continuity of treatment", checked: data.reasonContinuity },
    { label: "Patient history - Case Management services", checked: data.reasonHistory },
    { label: "Emergency contact - General Updates", checked: data.reasonEmergency },
    { label: "Court services - Legal purposes - Probation - Disability claiming - Unemployment", checked: data.reasonCourtLegal },
    { label: "claiming - Employment continuity", checked: data.reasonEmployment },
    { label: "Other: " + (data.reasonOtherDetails || "_______________________________________"), checked: data.reasonOtherChecked }
  ];

  // Legal text
  const legalText = [
    "I understand that my records are protected under Federal Confidentiality regulations",
    "(42 CFR Part 2) published August 10, 1987, and the Health Insurance Portability and",
    "Accountability Act of 1996 (P.L. 104-191), 42 U.S.C. Section 1320d, et. Seq and",
    "cannot be disclosed without my written consent unless otherwise provided for in the",
    "regulations. I understand that my medical record may contain information concerning",
    "my psychiatric, psychological, drug or alcohol abuse, HIV/Acquired Immune",
    "Deficiency Syndrome (AIDS) and/or related conditions. I understand that I may",
    "revoke this authorization at any time upon written notice to Legacy Healing Center",
    "Margate, LLC. I acknowledge that such revocation will not be effective if Legacy",
    "Healing Center Margate, LLC. has already acted in reliance upon this authorization.",
    "This authorization is valid (if not previously revoked) this consent will terminate upon",
    "365 days from the date of signature of this form, or the following event/condition:",
    "revocation, or the completion of treatment, or at the time of the final insurance billing",
    "whichever is latest. Prohibition on Re-disclosure",
    "This information has been disclosed from records protected by Federal Confidentiality",
    "rules (42 CFR part 2). The Federal rules prohibit making any further disclosure of this",
    "information unless further disclosure is expressly permitted with the written consent of",
    "the person to whom it pertains or as otherwise permitted by 42 CFR part 2. Federal",
    "rules restrict any use of the information to criminally investigate or prosecute any",
    "alcohol or drug abuse client."
  ];

  return (
    <div
      style={{
        fontFamily: "Arial",
        padding: "20px",
        maxWidth: "800px",
        margin: "0 auto",
        lineHeight: "1.2",
        height: "2430px",
        fontSize: "18px"
      }}
    >
      {/* Title */}
      <h1 style={{
        textAlign: 'center',
        fontSize: '18pt',
        fontWeight: 'bold',
        marginBottom: '20px'
      }}>
        Consent For Release of Confidential Information
      </h1>

      {/* Client Information */}
      <div style={{ marginBottom: '15px' }}>
        <div>
          I, {data.clientName || "_______________________"}, born on {data.dob || "_________"}, last four of Social Security
        </div>
        <div>
          Number: {data.ssnLast4 || "_________"}, authorize Legacy Healing Center Margate to:
        </div>
      </div>

      {/* Disclosure Direction */}
      <div style={{ marginBottom: '20px' }}>
        <div>
          <Checkbox checked={data.discloseTo} />
          <span>Disclose to</span>
        </div>
        <div>
          <Checkbox checked={data.obtainFrom} />
          <span>Obtain from</span>
        </div>
      </div>

      {/* Information Types */}
      <div style={{ fontWeight: 'bold', marginBottom: '10px' }}>
        The following information:
      </div>
      
      <div style={{ marginBottom: '20px' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <tbody>
            {informationTypes.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {row.map((info, colIndex) => (
                  <td key={colIndex} style={{ 
                    verticalAlign: 'top',
                    paddingBottom: '10px',
                    width: '33%'
                  }}>
                    {info && (
                      <div>
                        <Checkbox checked={info.checked} />
                        <span>{info.label}</span>
                      </div>
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Disclosure Method */}
      <div style={{ marginBottom: '20px' }}>
        <div style={{ fontWeight: 'bold' }}>Disclosure Method:</div>
        <div>
          <Checkbox checked={data.methodElectronic} />
          <span>Electronic</span>
          <Checkbox checked={data.methodOral} style={{ marginLeft: '30px' }} />
          <span>Oral</span>
          <Checkbox checked={data.methodWritten} style={{ marginLeft: '30px' }} />
          <span>Written</span>
        </div>
      </div>

      {/* Reason for Release */}
      <div style={{ marginBottom: '15px' }}>
        <div style={{ fontWeight: 'bold' }}>Reason for release of information:</div>
        <div>(Under the Mental Health Code, release of mental health records must be germane to the</div>
        <div>purpose and need for disclosure.)</div>
      </div>

      <div style={{ marginBottom: '20px' }}>
        {reasons.map((reason, i) => (
          <div key={i} style={{ marginBottom: '5px' }}>
            <Checkbox checked={reason.checked} />
            <span>{reason.label}</span>
          </div>
        ))}
      </div>

      {/* Legal Text */}
      <div style={{ marginBottom: '30px' }}>
        {legalText.map((line, i) => (
          <div key={i} style={{ marginBottom: '5px' }}>{line}</div>
        ))}
      </div>

      {/* Signature Section */}
      <div style={{ marginTop: '40px', marginBottom: '20px' }}>
        {signatureData ? (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img src={signatureData} alt="Signature" style={{ width: '150px', height: '60px' }} />
            <div style={{ marginLeft: '40px' }}>{data.date || "_____________"}</div>
          </div>
        ) : (
          <div style={{ display: 'flex' }}>
            <div>______________________________</div>
            <div style={{ marginLeft: '40px' }}>{data.date || "_____________"}</div>
          </div>
        )}
        
        <div style={{ display: 'flex', marginTop: '5px' }}>
          <div style={{ marginLeft: '40px' }}>Client Signature</div>
          <div style={{ marginLeft: '150px' }}>Date</div>
        </div>
      </div>
    </div>
  );
};

ConsentReleaseForm.propTypes = {
  data: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    clientName: PropTypes.string,
    dob: PropTypes.string,
    ssnLast4: PropTypes.string,
    discloseTo: PropTypes.bool,
    obtainFrom: PropTypes.bool,
    infoPresence: PropTypes.bool,
    infoMedical: PropTypes.bool,
    infoProgress: PropTypes.bool,
    infoAssessment: PropTypes.bool,
    infoAftercare: PropTypes.bool,
    infoDischarge: PropTypes.bool,
    infoTreatment: PropTypes.bool,
    infoLab: PropTypes.bool,
    infoPsych: PropTypes.bool,
    infoSummary: PropTypes.bool,
    infoEmployment: PropTypes.bool,
    infoPsychHistory: PropTypes.bool,
    infoLegal: PropTypes.bool,
    infoOther: PropTypes.string,
    infoOtherChecked: PropTypes.bool,
    infoPhysical: PropTypes.bool,
    infoFamily: PropTypes.bool,
    methodElectronic: PropTypes.bool,
    methodOral: PropTypes.bool,
    methodWritten: PropTypes.bool,
    reasonContinuity: PropTypes.bool,
    reasonHistory: PropTypes.bool,
    reasonEmergency: PropTypes.bool,
    reasonCourt: PropTypes.bool,
    reasonOther: PropTypes.string,
    reasonOtherChecked: PropTypes.bool,
    date: PropTypes.string
  }).isRequired,
  signatureData: PropTypes.string
};

export default ConsentReleaseForm;